// src/app/services/adpGage.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IVfd, IVfdParams, UpdatePayload } from '../models';

export const vfdApi = createApi({
  reducerPath: 'vfdApi',
  baseQuery,
  endpoints: (builder) => ({
    getVfdParams: builder.query<{ vfd: IVfdParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/motor_controllers/vfd/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getVfd: builder.query<IVfd, number>({
      query: (id) => `/api/v1.0/ahu/vfds/${id}`,
      transformResponse: (data: IVfd) => {
        data.params = data.vfd_params ? JSON.parse(data.vfd_params) : {};
        return data;
      },
    }),
    getAllVfdsCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/motor_controllers/vfd/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getVfdsCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/motor_controllers/vfd/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateVfd: builder.mutation<IVfd, UpdatePayload<IVfd>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/vfds/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: IVfd) => {
        data.params = data.vfd_params ? JSON.parse(data.vfd_params) : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetVfdQuery,
  useGetVfdParamsQuery,
  useGetAllVfdsCountQuery,
  useLazyGetVfdsCountQuery,
  useGetVfdQuery,
  useUpdateVfdMutation,
} = vfdApi;
